// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"422":"1fbf2e4a","712":"607b7519"}[chunkId] + ".chunk.css";
};